import React from 'react';
import PropTypes from 'prop-types';
import { useConnect } from '@lore/query-connect';
import useStewardshipFilter from '@/pages/events/useStewardshipFilter';
import REQUIRED_FIELDS from '@/pages/events/REQUIRED_FIELDS';
import { PayloadStates } from '@lore/utils';
import MetricLoader from '../MetricLoader';
import moment from 'moment-timezone';
import ComparisonMetric from '../ComparisonMetric';
import { tags_educator } from '@/utils/query-helpers';

export default function SharedEvent(props) {
  const { network, schoolStart, schoolEnd, titleOnly } = props;

  const stewardshipFilter = useStewardshipFilter();

  const previousSchoolStart = moment(schoolStart).subtract(1, 'year').toISOString();

  const previousUsers = useConnect('user.find', {
    where: {
      eager: {
        $aggregations: [
          {
            type: 'count',
            alias: 'numberOfEvents',
            relation: 'events',
            $where: {
              // published: true,
              activityId: {
                $null: false
              },
              networkId: network?.id,
              createdAt: {
                $lte: schoolStart,
                $gte: titleOnly ? undefined : previousSchoolStart
              },
              $and: REQUIRED_FIELDS.$and
            }
          }
        ],
        $where: {
          ...tags_educator(),
          $or: stewardshipFilter
        },
        $having: {
          numberOfEvents: {
            $gte: 1
          }
        }
      },
    },
    pagination: {
      pageSize: 1
    }
  });

  const newUsers = useConnect('user.find', {
    where: {
      eager: {
        $aggregations: [
          {
            type: 'count',
            alias: 'numberOfEvents',
            relation: 'events',
            $where: {
              // published: true,
              activityId: {
                $null: false
              },
              networkId: network?.id,
              createdAt: {
                $lte: schoolEnd,
                $gte: schoolStart
              },
              $and: REQUIRED_FIELDS.$and
            }
          }
        ],
        $where: {
          ...tags_educator(),
          $or: stewardshipFilter
        },
        $having: {
          numberOfEvents: {
            $gte: 1
          }
        }
      },
    },
    pagination: {
      pageSize: 1
    }
  });

  if (
    previousUsers.state === PayloadStates.FETCHING ||
    newUsers.state === PayloadStates.FETCHING
  ) {
    return (
      <MetricLoader
        name="Shared an Event"
      />
    );
  }

  return (
    <ComparisonMetric
      name="Shared an Event"
      value={newUsers.meta?.totalCount || 0}
      previousValue={previousUsers.meta?.totalCount || 0}
      titleOnly={titleOnly}
    />
  );
}

SharedEvent.propTypes = {
  network: PropTypes.object.isRequired,
  schoolStart: PropTypes.string.isRequired,
  schoolEnd: PropTypes.string.isRequired,
  titleOnly: PropTypes.bool
};
